import type { ISchedule, ISlot } from "@gettactic/api";

/**
 * Picks the slot whose capabilities describe what the current viewer can do
 * with a reservation. The API computes slot capabilities for the requesting
 * user on every slot, so when the viewer has no slot of their own (e.g. an
 * admin opening someone else's room reservation from the timeline) the
 * primary resource's slot still carries the viewer's permissions.
 */
export const getScheduleCapabilitySlot = (
  schedule: ISchedule,
  viewerUserId: string | undefined
): ISlot | undefined => {
  const userSlot = viewerUserId
    ? schedule.slots.find((slot) => slot.user.id === viewerUserId)
    : undefined;
  return (
    userSlot ??
    schedule.slots.find((slot) => slot.resource.id === schedule.resource.id) ??
    schedule.slots[0]
  );
};
